import Icon from '@ant-design/icons';
import { ReactComponent as SvgIcon } from './icon.svg';
import { ReactNode } from 'react';
import styled from '@emotion/styled';

function OtherCardMessage({ content }: { content: ReactNode }) {
  return (
    <Container>
      <Icon component={SvgIcon} />
      <div>{content}</div>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  max-width: 600px;
  padding: 8px;
  border: solid 8px #d6e8ff;
  border-radius: 14px;
  background: var(--fett-bg-panel);
  > span {
    margin-top: 4px;
    margin-right: 8px;
  }
  > div {
    flex: 1 0 0;
    white-space: pre-wrap;
  }
`;

export default OtherCardMessage;
